import { API } from "aws-amplify";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { GetExtensionSession } from "../graphql/queries";
import {
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  Notification,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
  Text,
  Header,
} from "grommet";
import { onUpdateExtensionSession } from "../graphql/subscriptions";
import { UpdateExtensionSession } from "../graphql/mutations";

export default function ExtensionSession() {
  const [extensionSession, setExtensionSession] = React.useState({});
  const [showToast, setShowToast] = React.useState(false);
  const [showRestart, setShowRestart] = React.useState(false);
  const { id } = useParams();
  useEffect(() => {
    getExtensionSession();

    const sub = API.graphql({
      query: onUpdateExtensionSession,
      variables: {
        filter: {
          session_code: { eq: id },
        },
      },
    }).subscribe({
      next: (data) => {
        console.log(data);
        getExtensionSession();
      },
      error: (error) => console.error(error),
    });

    return () => {
      sub.unsubscribe();
    };
  }, []);

  async function getExtensionSession() {
    try {
      const data = await API.graphql({
        query: GetExtensionSession,
        variables: {
          session_code: id,
        },
      });

      console.log(data);
      setExtensionSession(data.data.getExtensionSession);
    } catch (error) {
      console.error(error);
    }
  }

  async function finishSession() {
    try {
      const data = await API.graphql({
        query: UpdateExtensionSession,
        variables: {
          input: {
            session_code: extensionSession.session_code,
            status: "finished",
          },
        },
      });

      setShowToast(true);
    } catch (error) {
      console.error(error);
    }
  }

  async function restartSession() {
    try {
      const data = await API.graphql({
        query: UpdateExtensionSession,
        variables: {
          input: {
            session_code: extensionSession.session_code,
            status: "active",
          },
        },
      });

      setShowRestart(true);
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <Box align="center" justify="center" width="full" pad="large">
      {showToast && (
        <Notification
          toast
          onClose={() => setShowToast(false)}
          title="Session Status Set To Finished"
          message="The extension will now stop sending events"
          status="critical"
        />
      )}
      {showRestart && (
        <Notification
          toast
          onClose={() => setShowToast(false)}
          title="Session Status Set To Active"
          message="The extension will now send events"
          status="normal"
        />
      )}
      <Header>
        Be sure to finish the session when the candidate is done with the exam
      </Header>
      <Card margin="small" pad="small" fill="horizontal" height="75vh">
        <CardBody>
          <Box
            border
            fill
            width="full"
            pad="small"
            height="50vh"
            overflow="auto"
          >
            {extensionSession.events && (
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableCell scope="col" border="bottom" align="left">
                      <Text weight="bold">Event Timestamp (central)</Text>
                    </TableCell>
                    <TableCell scope="col" border="bottom" align="center">
                      <Text weight="bold">Event</Text>
                    </TableCell>
                    <TableCell scope="col" border="bottom" align="right">
                      <Text weight="bold">
                        Event Description (hover for a moment to view the full
                        description)
                      </Text>
                    </TableCell>
                  </TableRow>
                </TableHeader>
                <TableBody
                  style={{
                    overflowY: "scroll",
                    height: "50vh",
                  }}
                >
                  {extensionSession.events
                    .slice()
                    .reverse()
                    .map((event, idx) => (
                      <TableRow
                        key={event.event_timestamp}
                        style={{
                          borderBottom: "1px solid #000",
                          background: idx % 2 === 0 ? "#f0f0f0" : "#fff",
                        }}
                      >
                        <TableCell scope="row" align="left">
                          <Text>
                            {new Date(event.event_timestamp).toLocaleString(
                              "en-US",
                              {
                                timeZone: "America/Chicago",
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: true,
                              }
                            )}
                          </Text>
                        </TableCell>
                        <TableCell align="center">
                          <Text>{event.event}</Text>
                        </TableCell>
                        <TableCell align="right">
                          <Text
                            title={event.event_description}
                            style={{
                              maxWidth: "300px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              cursor: "help",
                            }}
                          >
                            {event.event_description &&
                            event.event_description.length > 60
                              ? `${event.event_description.substring(0, 60)}...`
                              : event.event_description}
                          </Text>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            )}
          </Box>
        </CardBody>
        <CardFooter>
          <Box
            align="start"
            justify="start"
            pad="small"
            direction="column"
            width="full"
          >
            <Text weight="bold">
              Session Code: {extensionSession.session_code}
            </Text>
            <Text>Tester Name: {extensionSession.candidate_name}</Text>
            <Text>Exam Name: {extensionSession.exam_name}</Text>
            <Text>Status: {extensionSession.status}</Text>
          </Box>
          <Box>
            <Text>Total Events: {extensionSession?.events?.length}</Text>
          </Box>
          <Box>
            {extensionSession.status === "active" ? (
              <Button label="Finish Session" onClick={finishSession} />
            ) : (
              <Button label="Restart Session" onClick={restartSession} />
            )}
          </Box>
        </CardFooter>
      </Card>
    </Box>
  );
}
